import React from 'react';
import { Box, Typography } from '@mui/material';

function GeneralStatusCard({ widget, data, theme }) {
  const isDark = theme === 'dark';
  const liveData = Array.isArray(data) ? data : [];
  const tagprops = widget?.props?.extended?.tagprops || [];

  const items = tagprops.length > 0
    ? tagprops.map((tp) => {
        const match = liveData.find((d) => String(d.TagId) === String(tp.tagId));
        const val = match?.value;
        return { label: tp.alias || tp.tagId, isOn: val === '1' || val === 1, key: tp.tagId };
      })
    : [{ label: '—', isOn: false, key: '__empty__' }];

  return (
    <Box sx={{ flex: 1, minHeight: 0, width: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', px: 1, py: 0.25 }}>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', gap: 0.25 }}>
        {items.map((item) => (
          <Box key={item.key} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flex: '1 1 0', minHeight: 0 }}>
            <Typography variant="body2" sx={{ color: isDark ? '#ccc' : '#333', pr: 1 }}>{item.label}</Typography>
            <Box sx={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: item.isOn ? 'green' : 'red', flexShrink: 0 }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default React.memo(GeneralStatusCard);
